<o-header id="header" [tocNav]="tocSidenav" [settingsSidenav]="settingsSidenav" oSticky></o-header>

<mat-sidenav-container class="layoutContainer">
  <mat-sidenav
    #toc
    autoFocus="false"
    opened="false"
    [mode]="store.tocMode"
    class="toc-sidenav ori-elevation-z5"
    color="primary">
    <div class="toc-header" [style.background-image]="tocHeaderBackground">
      <button class="back-button" mat-button (click)="backToStore()">
        <mat-icon class="logout" svgIcon="logout"></mat-icon>
        <span class="back">{{ "back.store" | translate }}</span>
      </button>
      <div class="pub-infos" (click)="backToLoap()">
        <div class="title">
          {{ pub?.product ? pub.product + " " : "" }}
          {{ pub.verbatimText }}
        </div>
        {{ pub?.manualCode !== "ORIO" ? pub?.manualCode : "ORION" }}
        <div class="revision">
          <img alt="flag icon" class="flag-icon" [src]="'./assets/flags/' + pub.lang + '.svg'" />
          {{ displayedRevision }} -
          @if (pub?.revisionDate) {
            {{ pub.revisionDate | safeDate: "yyyy-MM-dd" }}
          }
        </div>
      </div>
      <div class="applic" (click)="openApplicModal()">
        <div>
          {{ applicabilityService.userSelectedCriterias?.version | versionMapping: store.pubInfo?.model }}
        </div>
        @if (applicabilityService.userSelectedCriterias?.serialno) {
          <div>- {{ applicabilityService.userSelectedCriterias.serialno }}</div>
        }
        <mat-icon svgIcon="filter"></mat-icon>
      </div>
    </div>
    <o-toc></o-toc>
  </mat-sidenav>

  <mat-sidenav
    #settings
    position="end"
    opened="false"
    mode="over"
    class="settings-sidenav ori-elevation-z5"
    color="primary">
    <o-settings [settingsSidenav]="settingsSidenav" />
  </mat-sidenav>

  <!-- Player 3D -->
  @if (store.isPlayerActivated && domIsReady) {
    <o-player id="player"></o-player>
  }

  <router-outlet (activate)="scrollTop()"></router-outlet>
</mat-sidenav-container>
